import { useState, useEffect } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputCombo from "../../helpers/InputCombo";



function KidDeleteMass(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

  

    const [op, setOp] = useState({
        ids: props.ids,                 
        dziecko: 0,
        rodzic_1: 0,
        rodzic_2: 0,
        osoby_upw: 0,
        wiadomosci: 0,
        posty: 0,
    });

    var tmpRow = op;


    var optionDelDziecko = [
        {
            v: '0',
            title: 'Pozostaw bez zmian (zalecane)'
        },
       // {
         //   v: '1',
        //    title: 'Wyczyść wszystkie dane'
      //  },
        {
            v: '2',
            title: 'Wyczyść wszystkie dane z wyjątkiem imienia i nazwiska'
        },
      ];


      var optionDelRodzic = [
        {
            v: '0',
            title: 'Pozostaw bez zmian  (zalecane)'
        },
        {
            v: '1',
            title: 'Wyczyść wszystkie dane'
        },
        {
            v: '2',
            title: 'Wyczyść wszystkie dane z wyjątkiem imienia i nazwiska'
        },
      ];


      var optionDel = [
        {
            v: '0',
            title: 'Pozostaw bez zmian  (zalecane)'
        },
        {
            v: '1',
            title: 'Wyczyść wszystkie dane'
        }        
      ];


      const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
    

      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setOp(  JSON.parse(JSON.stringify(tmpRow)) );            
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }


    const goDelete = (e) => {

     return   saveData('none');
     
        props.mainView.showDialog("Potwierdź", "Potwierdź operacje kodem SMS:", "auth", (crypt)=>{
          
                        ///--------
                        if(crypt != null) 
                            {
                                    saveData(crypt);
                            }
                        //--------
        } );
    }


    const saveData = (crypt) => {

 

        if(crypt.length<3) return;



        props.mainView.setProgress(-2);

      

        

        var req = op;
        req["crypt"] = crypt;

        fetch( Config.url + '/rest_v1_kids,kid_delete', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Wskazane dane zostały usunięte", "ok" , null);         
                        
                        Config.removeFromBuffer( Config.cache_kids_search, props.userData );
                        
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }


  //  console.log("OP",op);


    return (
        
        <div className="view_content">

            

                <form className="eForm bg_center">


                    <div className="form_tab">


                                   <div className="form_control">
                                   <div className="fieldName">Dzieci wybrane do usunięcia:</div>
                                   <br/>&nbsp; 
                                    {
                                        op.ids.map(  (item, ix) => {
                                                    return <b className="amount_minus">
                                                            {item.title},&nbsp; 
                                                    </b>
                                        } )
                                    }
                                    </div>

                                    <div className="form_split"></div>
                                    <br/>
                                    <div className="form_split"></div>


                                    <div className="form_control">
                                                <div className="fieldName">Dziecko</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={optionDelDziecko} value={op.dziecko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dziecko" placeholder={":"} className='  ' req='0'   />
                                    </div>


                                    <div className="form_split"></div>


                                    <div className="form_control">
                                                <div className="fieldName">Rodzic / Opiekun 1</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={optionDelRodzic} value={op.rodzic_1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rodzic_1" placeholder={":"} className='  ' req='0'   />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Rodzic / Opiekun 2</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={optionDelRodzic} value={op.rodzic_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rodzic_2" placeholder={":"} className='  ' req='0'   />
                                    </div>


                                    
                                    <div className="form_split"></div>


                                    <div className="form_control">
                                                <div className="fieldName">Osoby upoważnione</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={optionDel} value={op.osoby_upw} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="osoby_upw" placeholder={":"} className='  ' req='0'   />
                                    </div>

                                    <div className="form_split"></div>


                                    <div className="form_control">
                                                <div className="fieldName">Wiadomości (wysłane i odebrane przez rodziców)</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={optionDel} value={op.wiadomosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wiadomosci" placeholder={":"} className='  ' req='0'   />
                                    </div>


                                    <div className="form_split"></div>


                                    <div className="form_control">
                                                <div className="fieldName">Posty opublikowane przez rodziców</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={optionDel} value={op.posty} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="posty" placeholder={":"} className='  ' req='0'   />
                                    </div>




                                    <div className="form_split"></div>


                                    <div className="form_btn">
                                            <div className="btn" onClick={goDelete}>zapisz zmiany</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>


                    </div>


                </form>

        </div>
    )
}


export default KidDeleteMass;